import { appApiHeaders, getApiUrl } from '@/utils/api-utils'
import { apiCall } from '@ngtrvu/use-api'

const UNSPLASH_TRACK_DOWNLOAD = 'UNSPLASH_TRACK_DOWNLOAD'

export const trackDownloadApi = apiCall(
  UNSPLASH_TRACK_DOWNLOAD,
  ({ siteId, url }: { siteId: string; url: string }) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/unsplash/track`),
    method: 'POST',
    body: {
      url,
    },
    headers: appApiHeaders(),
  }),
)
